// store/authStore.js
import { create } from "zustand";
import Cookies from "js-cookie";
import { axiosInstance } from "../lib/axios";
import { useNavigate } from "react-router-dom";
import { loginapi, checkAuthapi, getAllUserFunctionApi, registeruser, deleteuser, dowloaduserslist, resetpassword } from "../api/auth.js";


let globalNavigate = null;

export const setNavigator = (nav) => {
    globalNavigate = nav;
};

export const useAuthStore = create((set, get) => ({
    authUser: null,
    isSigningUp: false,
    isUpdatingProfile: false,
    isCheckingAuth: true,
    loading: false,
    hasTriedAuth: false,
    users: [],

    checkAuth: async () => {
        try {
            set({ loading: true })
            const res = await checkAuthapi()
            if (res) {
                set({ authUser: res })
            }
            set({ loading: false, hasTriedAuth: true })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getUserAllFunctionApi: async (pageNumber, pageSize, search, field) => {
        try {
            // set({ loading: true })
            const res = await getAllUserFunctionApi(pageNumber, pageSize, search, field)
            set({ users: res?.ref })
            return res
        } catch (error) {
            console.log("Internal server error:", error);
            set({ loading: null });
            return false;
        }
    },
    // LOGIN
    login: async (email, password) => {
        set({ isCheckingAuth: true, loading: true });

        try {
            const res = await loginapi(email, password)

            if (res?.accessToken)
                Cookies.set("accessToken", res?.accessToken, {
                    secure: true,
                    expires: 15 / (24 * 60),
                });

            if (res?.refreshToken)
                Cookies.set("refreshToken", res?.refreshToken, {
                    secure: true,
                    expires: 7,
                });

            set({ authUser: res?.user, isCheckingAuth: false, loading: false });

            if (globalNavigate && typeof globalNavigate === "function") {
                globalNavigate("/");
            }
        } catch (error) {
            console.error("Login failed:", error);
            set({ isCheckingAuth: false });
            throw error;
        }
    },
    // logout
    logout: () => {
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        set({ authUser: null });
        if (globalNavigate) globalNavigate("/login");
    },
    // REFRESH TOKEN
    refreshToken: async () => {
        try {
            console.log("refresh tokens")
            const token = Cookies.get("refreshToken")

            const response = await axiosInstance.post(`/users/refresh-token`, {},
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            const newAccessToken = response.data.data.accessToken;
            // await delay(100);
            Cookies.set("accessToken", response.data.data.accessToken, { expires: 15 / 1440 })
            // await delay(100);
            Cookies.set("refreshToken", response.data.data.refreshToken, { expires: 7 })
            // const { accessToken } = res.data;
            // Cookies.set("accessToken", accessToken, { secure: true });

            // return accessToken;
        } catch (err) {
            console.error("Refresh token failed:", err);
            get().logout();
            throw err;
        }
    },
    registerUser: async (formData) => {
        try {
            set({ loading: true })
            const res = await registeruser(formData)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ loading: false })
            return false;
        } finally {
            set({ loading: false })
        }
    },
    deleteUser: async (id) => {
        try {
            set({ loading: true })
            const res = await deleteuser(id)
            const currentUser = get().users || [];
            const updatedUser = currentUser.filter((ele) => ele._id !== id);
            set({ loading: false, user: updatedUser });
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    dowloadUser: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await dowloaduserslist(pageNumber, pageSize, search, field)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Internal server error:", error);
            set({ category: null });
            return false;
        }
    },
    resetPassword: async (formData) => {
        try {
            set({ loading: true })
            const res = await resetpassword(formData)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ loading: false })
            return false;
        } finally {
            set({ loading: false })
        }
    },
}));
